'use strict';
String.prototype.replaceAll = function (s, r) { return this.split(s).join(r) }

DoohApps
    .directive('configuratorblocks', ['$compile', '$http', '$q', '$window', '$filter', 'modal2', 'ConfigurationBlockHelper', function ($compile, $http, $q, $window, $filter, modal2, ConfigBlockHelper) {
        var addBlock = function (array, ob, key, block) {
            if (typeof array['_' + block.GroupName] == 'undefined') array['_' + block.GroupName] = '';
            array['_' + block.GroupName] += ob.replaceAll('[[key]]', key)
                .replaceAll('[[blockCode]]', block.BlockID);
        }
        var getTemplate = function (configblocks, blocktemplates, fun, model, canManage, advancedGroupList, advancedBlockGroups) {
            var blockGroups = [];
            var blockWraper = blocktemplates[0].data;
            var checkbox = blocktemplates[1].data;
            var colorVideoImagePicker = blocktemplates[2].data;
            var effect = blocktemplates[3].data;
            var effectColor = blocktemplates[4].data;
            var positioning = blocktemplates[5].data;
            var singleSelect = blocktemplates[6].data;
            var slider = blocktemplates[7].data;
            var colVidImgPickAttachments = blocktemplates[8].data;
            var textInput = blocktemplates[9].data;
            var region = blocktemplates[10].data;
            var webAppPreview = blocktemplates[11].data;
            var hidden = blocktemplates[12].data;
            var simpleMediaPicker = blocktemplates[13].data;
            var jsonEditor = blocktemplates[14].data;
            var mediaList = blocktemplates[15].data;
            var multiSelect = blocktemplates[16].data;
            var textBlock = blocktemplates[17].data;
            var defval, val, settings;

            var blockType = ConfigBlockHelper.configurationBlockType;

            angular.forEach(configblocks, function (block, key) {
                if (advancedBlockGroups != undefined) {
                    if (block.hide == undefined) {
                        if (block.IsAdvanced == true) block.hide = true;
                        else block.hide = false;
                    }
                }
                else block.hide = false;

                switch (block.BlockName) {
                    case blockType.multiSelect:
                        if (typeof block.Options == 'string') {
                            block.OptionsString = block.Options;
                            if (block.ConfigurationValue != '') {
                                block.Options = JSON.parse(block.Options);
                            }
                        }
                        if (typeof block.ConfigurationValue === 'string' && block.ConfigurationValue != '') {
                            block.ConfigurationValue = JSON.parse(block.ConfigurationValue);
                        }

                        angular.forEach(block.Options, function (v, k) {
                            v.ticked = false;

                            angular.forEach(block.ConfigurationValue, function (v2, k) {
                                if (v.res == v2)
                                    v.ticked = true;
                            });
                        });
                        addBlock(blockGroups, multiSelect, key, block);
                        break;

                    case blockType.colorVideoImagePicker:

                        if (typeof block.ConfigurationValue === 'string' && block.ConfigurationValue != '') {
                            block.ConfigurationValue = JSON.parse(block.ConfigurationValue);
                        }
                        if (typeof block.Options === 'string' && block.ConfigurationValue != '') {
                            block.Options = JSON.parse(block.Options);
                        }

                        if (block.hide && typeof block.ConfigurationValue != 'string') {
                            defval = JSON.parse(block.DefaultValue);
                            if (block.ConfigurationValue.Active != undefined && block.ConfigurationValue.Color == undefined) {
                                if (block.ConfigurationValue.Active == 'Img') {
                                    if (block.ConfigurationValue.Image == undefined) block.hide = true;
                                    else block.hide = false;
                                }
                                else if (block.ConfigurationValue.Active == 'Vid') {
                                    if (block.ConfigurationValue.Video == undefined) block.hide = true;
                                    else block.hide = false;
                                }
                            }
                            else {
                                if (block.ConfigurationValue.Color != undefined) {
                                    if (defval.Color == block.ConfigurationValue.Color) {
                                        block.hide = true;
                                    }
                                    else block.hide = false;
                                }
                                else block.hide = false;
                            }
                        }

                        addBlock(blockGroups, colorVideoImagePicker, key, block);
                        break;
                    case blockType.effectSelect:
                        if (block.hide && typeof block.ConfigurationValue === 'string') {
                            if (block.DefaultValue.trim() != block.ConfigurationValue.trim()) block.hide = false;
                        }
                        if (typeof block.Options == 'string') {
                            block.OptionsString = block.Options;
                            if (block.ConfigurationValue != '') {
                                block.Options = JSON.parse(block.Options);
                            }
                        }
                        if (typeof block.ConfigurationValue === 'string' && block.ConfigurationValue != '') {
                            block.ConfigurationValue = JSON.parse(block.ConfigurationValue);
                        }

                        angular.forEach(block.Options, function (v, k) {
                            v.selected = false;
                            angular.forEach(block.ConfigurationValue, function (v2, k) {
                                if (JSON.stringify(v.value) === JSON.stringify(v2)) v.selected = true;
                            });
                        });
                        addBlock(blockGroups, effect, key, block);
                        break;
                    case blockType.effectColor:

                        if (typeof block.ConfigurationValue === 'string' && block.ConfigurationValue != '') {
                            block.ConfigurationValue = JSON.parse(block.ConfigurationValue);
                        }

                        if (block.hide && typeof block.ConfigurationValue != 'string') {
                            defval = JSON.parse(block.DefaultValue);
                            if (defval.Color == block.ConfigurationValue.Color) {
                                block.hide = true;
                            }
                            else block.hide = false;
                        }

                        addBlock(blockGroups, effectColor, key, block);

                        break;

                    case blockType.positioning:
                        block.mode = {};
                        if (block.hide && typeof block.ConfigurationValue === 'string') {
                            if (block.DefaultValue.trim() != block.ConfigurationValue.trim()) block.hide = false;
                        }
                        if (typeof block.ConfigurationValue === 'string' && block.ConfigurationValue != '') {
                            block.ConfigurationValue = JSON.parse(block.ConfigurationValue);
                        }
                        if (block.Settings != null && block.Settings != 'N/A') {

                            settings = block.Settings;
                            if (typeof settings === 'string' && settings != '') {
                                settings = JSON.parse(settings);
                                if (typeof settings != 'string') {
                                    if (settings.Interaction != undefined) block.Interaction = settings.Interaction;
                                }
                            }
                            angular.forEach(configblocks, function (bl, key2) {
                                if (bl.BlockName != blockType.positioning && bl.BlockName != blockType.region) {
                                    if (block.Interaction != undefined) {
                                        if (block.Interaction.areaBackground == bl.Code) {
                                            if (typeof bl.ConfigurationValue === 'string' && bl.ConfigurationValue != '') {
                                                bl.ConfigurationValue = JSON.parse(bl.ConfigurationValue);
                                            }
                                            block.Interaction.areaBackground = key2;//bl.ConfigurationValue;
                                        }
                                        if (block.Interaction.areaBackgroundPosition == bl.Code) {
                                            if (typeof bl.ConfigurationValue === 'string' && bl.ConfigurationValue != '') {
                                                bl.ConfigurationValue = JSON.parse(bl.ConfigurationValue);
                                            }
                                            block.Interaction.areaBackgroundPosition = key2;
                                        }
                                        if (typeof block.Interaction.landscape == 'string' && block.Interaction.landscape.indexOf(bl.Code) != -1) {
                                            if (typeof bl.ConfigurationValue === 'string' && bl.ConfigurationValue != '') {
                                                bl.ConfigurationValue = JSON.parse(bl.ConfigurationValue);
                                            }

                                            val = block.Interaction.landscape.split('=');
                                            block.Interaction.landscape = { key: key2, value: val[1] };
                                        }
                                        if (typeof block.Interaction.ratio169 == 'string' && block.Interaction.ratio169.indexOf(bl.Code) != -1) {
                                            if (typeof bl.ConfigurationValue === 'string' && bl.ConfigurationValue != '') {
                                                bl.ConfigurationValue = JSON.parse(bl.ConfigurationValue);
                                            }

                                            val = block.Interaction.ratio169.split('=');
                                            block.Interaction.ratio169 = { key: key2, value: val[1] };
                                        }
                                    }

                                }

                            });
                        }
                        addBlock(blockGroups, positioning, key, block);
                        break;
                    case blockType.region:
                        block.mode = {};
                        if (block.hide && typeof block.ConfigurationValue === 'string') {
                            if (block.DefaultValue.trim() != block.ConfigurationValue.trim()) block.hide = false;
                        }
                        if (typeof block.ConfigurationValue === 'string' && block.ConfigurationValue != '') {
                            block.ConfigurationValue = JSON.parse(block.ConfigurationValue);
                        }
                        if (block.Settings != null && block.Settings != 'N/A') {

                            settings = block.Settings;
                            if (typeof settings === 'string' && settings != '') {
                                settings = JSON.parse(settings);
                                if (typeof settings != 'string') {
                                    if (settings.Interaction != undefined) block.Interaction = settings.Interaction;
                                }
                            }
                            angular.forEach(configblocks, function (bl, key2) {
                                if (bl.BlockName != blockType.positioning && bl.BlockName != blockType.region) {
                                    if (block.Interaction != undefined) {
                                        if (block.Interaction.areaBackground == bl.Code) {
                                            if (typeof bl.ConfigurationValue === 'string' && bl.ConfigurationValue != '') {
                                                bl.ConfigurationValue = JSON.parse(bl.ConfigurationValue);
                                            }
                                            block.Interaction.areaBackground = key2;//bl.ConfigurationValue;
                                        }
                                        if (block.Interaction.areaBackgroundPosition == bl.Code) {
                                            if (typeof bl.ConfigurationValue === 'string' && bl.ConfigurationValue != '') {
                                                bl.ConfigurationValue = JSON.parse(bl.ConfigurationValue);
                                            }
                                            block.Interaction.areaBackgroundPosition = key2;
                                        }
                                        if (typeof block.Interaction.landscape == 'string' && block.Interaction.landscape.indexOf(bl.Code) != -1) {
                                            if (typeof bl.ConfigurationValue === 'string' && bl.ConfigurationValue != '') {
                                                bl.ConfigurationValue = JSON.parse(bl.ConfigurationValue);
                                            }

                                            val = block.Interaction.landscape.split('=');
                                            block.Interaction.landscape = {
                                                key: key2, value: val[1]
                                            };
                                        }
                                        if (typeof block.Interaction.ratio169 == 'string' && block.Interaction.ratio169.indexOf(bl.Code) != -1) {
                                            if (typeof bl.ConfigurationValue === 'string' && bl.ConfigurationValue != '') {
                                                bl.ConfigurationValue = JSON.parse(bl.ConfigurationValue);
                                            }

                                            val = block.Interaction.ratio169.split('=');
                                            block.Interaction.ratio169 = { key: key2, value: val[1] };
                                        }
                                    }

                                }

                            });
                        }

                        addBlock(blockGroups, region, key, block);
                        break;
                    case blockType.checkbox:
                        if (block.hide && typeof block.ConfigurationValue === 'string') {
                            if (block.DefaultValue.trim() != block.ConfigurationValue.trim()) block.hide = false;
                        }
                        if (typeof block.ConfigurationValue === 'string' && block.ConfigurationValue != '') {
                            block.ConfigurationValue = JSON.parse(block.ConfigurationValue);
                        }
                        addBlock(blockGroups, checkbox, key, block);

                        break;
                    case blockType.textInput:
                        if (block.hide && typeof block.ConfigurationValue === 'string') {
                            if (block.DefaultValue.trim() != block.ConfigurationValue.trim()) block.hide = false;
                        }
                        if (typeof block.Options === 'string' && block.ConfigurationValue != '') {
                            block.Options = JSON.parse(block.Options);
                        }
                        if (typeof block.ConfigurationValue === 'string' && block.ConfigurationValue != '') {
                            block.ConfigurationValue = JSON.parse(block.ConfigurationValue);
                        }
                        addBlock(blockGroups, textInput, key, block);

                        break;
                    case blockType.singleSelect:
                    case blockType.languageSelect:
                        if (typeof block.Options == 'string') {
                            block.OptionsString = block.Options;
                            if (block.ConfigurationValue != '') {
                                block.Options = JSON.parse(block.Options);
                            }
                        }
                        if (typeof block.ConfigurationValue === 'string' && block.ConfigurationValue != '') {
                            block.ConfigurationValue = JSON.parse(block.ConfigurationValue);
                        }
                        angular.forEach(block.Options, function (opt, key) {
                            if (opt.icon != undefined && opt.icon != '') opt.icont = '<img src=' + opt.icon + ' />';
                            else opt.icont = '';
                            if (opt.ticked == true) block.ConfigurationValue = [opt.res];
                        });

                        if (block.hide && typeof block.ConfigurationValue != 'string') {
                            defval = JSON.parse(block.DefaultValue);
                            if (defval[0] == block.ConfigurationValue[0]) {
                                block.hide = true;
                            }
                            else block.hide = false;

                        }

                        angular.forEach(block.Options, function (v, k) {

                            v.ticked = false;
                            angular.forEach(block.ConfigurationValue, function (v2, k) {
                                if (v.res == v2)
                                    v.ticked = true;
                            });
                        });

                        addBlock(blockGroups, singleSelect, key, block);
                        break;
                    case blockType.slider:
                        if (block.hide && typeof block.ConfigurationValue === 'string') {
                            if (block.DefaultValue.trim() != block.ConfigurationValue.trim()) block.hide = false;
                        }
                        if (typeof block.Options === 'string' && block.ConfigurationValue != '') {
                            block.Options = JSON.parse(block.Options);
                        }
                        if (typeof block.ConfigurationValue === 'string' && block.ConfigurationValue != '') {
                            block.ConfigurationValue = JSON.parse(block.ConfigurationValue);
                        }

                        addBlock(blockGroups, slider, key, block);
                        break;
                    case blockType.colVidImgPickerWithAttachments:
                        if (block.hide && typeof block.ConfigurationValue === 'string') {
                            if (block.DefaultValue.trim() != block.ConfigurationValue.trim()) block.hide = false;
                        }
                        if (typeof block.ConfigurationValue === 'string' && block.ConfigurationValue != '') {
                            block.ConfigurationValue = JSON.parse(block.ConfigurationValue);
                        }
                        if (typeof block.Options === 'string' && block.Options != 'N/A') block.Options = JSON.parse(block.Options);

                        addBlock(blockGroups, colVidImgPickAttachments, key, block);
                        break;
                    case blockType.webAppPreview:
                        if (typeof block.Options == 'string') {
                            block.OptionsString = block.Options;
                            if (block.ConfigurationValue != '') {
                                block.Options = JSON.parse(block.Options);
                            }
                        }
                        if (typeof block.ConfigurationValue === 'string' && block.ConfigurationValue != '') {
                            block.ConfigurationValue = JSON.parse(block.ConfigurationValue);
                        }

                        addBlock(blockGroups, webAppPreview, key, block);
                        break;
                    case blockType.hidden:
                        if (canManage) addBlock(blockGroups, hidden, key, block);
                        break;

                    case blockType.jsonEditor:
                        if (block.hide && typeof block.ConfigurationValue === 'string') {
                            if (block.DefaultValue.trim() != block.ConfigurationValue.trim()) block.hide = false;
                        }
                        if (typeof block.Options === 'string' && block.ConfigurationValue != '') {
                            block.Options = JSON.parse(block.Options);
                        }
                        if (typeof block.ConfigurationValue === 'string' && block.ConfigurationValue != '') {
                            block.ConfigurationValue = { 'value': JSON.parse(block.ConfigurationValue) };
                        }

                        addBlock(blockGroups, jsonEditor, key, block);
                        break;

                    case blockType.simpleMediaPicker:
                        if (block.hide && typeof block.ConfigurationValue === 'string') {
                            if (block.DefaultValue.trim() != block.ConfigurationValue.trim()) block.hide = false;
                        }
                        if (typeof block.ConfigurationValue === 'string' && block.ConfigurationValue != '') {
                            block.ConfigurationValue = JSON.parse(block.ConfigurationValue);
                        }
                        if (typeof block.Options === 'string' && block.Options != 'N/A') block.Options = JSON.parse(block.Options);
                        addBlock(blockGroups, simpleMediaPicker, key, block);
                        break;

                    case blockType.mediaList:
                        if (block.hide && typeof block.ConfigurationValue === 'string') {
                            if (block.DefaultValue.trim() != block.ConfigurationValue.trim()) block.hide = false;
                        }
                        if (typeof block.Options === 'string' && block.ConfigurationValue != '') {
                            block.Options = JSON.parse(block.Options);
                        }
                        if (typeof block.ConfigurationValue === 'string' && block.ConfigurationValue != '') {
                            block.ConfigurationValue = JSON.parse(block.ConfigurationValue);
                        }

                        addBlock(blockGroups, mediaList, key, block);
                        break;

                    case blockType.textBlock:
                        if (block.hide && typeof block.ConfigurationValue === 'string') {
                            if (block.DefaultValue.trim() != block.ConfigurationValue.trim()) block.hide = false;
                        }
                        if (typeof block.Options === 'string' && block.ConfigurationValue != '') {
                            block.Options = JSON.parse(block.Options);
                        }
                        if (typeof block.ConfigurationValue === 'string' && block.ConfigurationValue != '') {
                            block.ConfigurationValue = JSON.parse(block.ConfigurationValue);
                        }

                        addBlock(blockGroups, textBlock, key, block);
                        break;

                    default:
                        if (typeof blockGroups['_' + block.GroupName] == 'undefined') blockGroups['_' + block.GroupName] = '';
                        break;
                }
            });

            var template = '';
            if (advancedGroupList != undefined) {
                var groups = [], group;
                for (var key in blockGroups) {
                    var groupTitle = key.substr(1, key.length - 1);
                    group = $filter('filter')(configblocks, { GroupName: groupTitle }, true);
                    groups.push(group);
                }
                angular.forEach(groups, function (group, key) {
                    var advCount = 0;
                    angular.forEach(group, function (block, key2) {
                        if (block.IsAdvanced) advCount++;
                        if (block.hide == true)//typeof block.ConfigurationValue != 'string' &&
                            if (advancedBlockGroups.indexOf(block.GroupName) == -1) advancedBlockGroups.push(block.GroupName);
                    });
                    if (advCount == group.length) {
                        if (typeof (group[0]) !== 'undefined' && advancedGroupList.indexOf(group[0].GroupName) == -1)
                            advancedGroupList.push(group[0].GroupName);
                    }
                });
                if (advancedGroupList.length > 0) {
                    var i = advancedGroupList.length;
                    while (i--) {
                        group = $filter('filter')(configblocks, { GroupName: advancedGroupList[i] }, true);
                        for (var j = 0; j < group.length; j++) {
                            if (group[j].hide == false) {
                                advancedGroupList.splice(i, 1);
                                break;
                            }
                        }

                    }

                }

            }


        for (var groupKey in blockGroups) {
            if (typeof (groupKey) != 'undefined' && blockGroups.hasOwnProperty(groupKey)) {
                var blockGroupTitle = groupKey.substr(1, groupKey.length - 1);
                    template += blockWraper
                    .replace('[[BLOCKS]]', blockGroups[groupKey])
                    .replace('[[TITLE]]', blockGroupTitle)
                    .replaceAll('[[GROUP]]', blockGroupTitle)
                    .replaceAll('[[GROUP1]]', blockGroupTitle.replace(/ /g, ''));
                }
            }

            return template;
        };

        return {
            require: 'ngModel',
            restrict: 'AE',
            scope: {
                configblocks: '=',
                blocktemplates: '=',
                ngModel: '=',
                addAssetDialog: '&',
                index: '=',
                gridsteropts: '=',
                addBlock: '&',
                drawchange: '=',
                campaignid: '=',
                removeBlock: '&',
                moveGroup: '&',
                noChangeAllowed: '=',
                canManage: '=',
                advancedGroupList: '=advancedGroupList',
                advancedShow: '=',
                advancedBlockGroups: '=advancedBlockGroups'
            },
            link: function (scope, element, attrs, ctrl) {
                //scope.advancedGroupList = [];
                scope.change = 0;//multi attachment picker
                scope.maxEffects = 0;
                scope.selectedEffects = 0;
                //scope.showAdvBlocks = false;
                scope.isAdvanced = function (groupName) {
                    if (scope.advancedGroupList != undefined) {
                        if (scope.advancedGroupList.length > 0) {
                            if (scope.advancedGroupList.indexOf(groupName) != -1) return true;
                            else return false;
                        }
                        else return false;
                    }
                    return false;
                }
                var showAdwancedGroups = [];
                scope.showAdvBlocks = function (groupName) {

                    if (scope.advancedBlockGroups != undefined) {
                        var group = $filter('filter')(scope.configblocks, { GroupName: groupName }, true);
                        var showIndex = showAdwancedGroups.indexOf(groupName);
                        if (showIndex != -1) {
                            angular.forEach(group, function (block, key) {
                                if (block.wasNotHidden == true) block.hide = false;
                                else block.hide = true;
                            });
                            showAdwancedGroups.splice(showIndex, 1);
                        }
                        else {
                            angular.forEach(group, function (block, key) {
                                if (block.hide == false) block.wasNotHidden = true;
                                else block.hide = false;
                            });
                            showAdwancedGroups.push(groupName);
                        }
                    }

                }

                scope.showEye = function (groupName) {
                    return (showAdwancedGroups.indexOf(groupName) != -1);
                }

                scope.showAdvBlockLink = function (group) {
                    if (scope.advancedBlockGroups != undefined) {
                        var index = scope.advancedBlockGroups.indexOf(group);
                        if (index != -1) return true;
                        else return false;
                    }
                    return false;
                }

                scope.selectEffect = function (effect, options) {//effect select
                    /*maxEffects is used to specify max number of items user can select. This option has to be added last to the configuration block options. If option is not specified,
                     * block is treated like single select. */
                    scope.maxEffects = options[options.length - 1].maxEffects || '';
                    if (scope.maxEffects == '') {
                        angular.forEach(options, function (opt) {
                            if (opt.value != null)
                                if (opt.value != effect.value) opt.selected = false;
                                else opt.selected = true;
                        })
                    } else {
                        effect.selected = !effect.selected;
                        if (effect.selected)
                            scope.selectedEffects++;
                        else scope.selectedEffects--;

                        if (scope.selectedEffects < 1 || scope.selectedEffects > scope.maxEffects) {
                            effect.selected = !effect.selected;
                            if (effect.selected)
                                scope.selectedEffects++;
                            else scope.selectedEffects--;
                        }
                    }

                };

                scope.setZindex = function (key) {
                    scope.zVal = key;
                }

                scope.initEffectSelect = function (options) {
                    scope.maxEffects = options[options.length - 1].maxEffects || '';
                    if (scope.maxEffects != '') {
                        angular.forEach(options, function (opt) {
                            if (opt.selected)
                                scope.selectedEffects++;
                        });
                    }
                }

                scope.selectMediaItem = function (index, key, changeSelect) {//multi attachment picker  
                    scope.index[key] = index;
                    if (changeSelect && scope.configblocks[[[key]]].ConfigurationValue.ValueArray[scope.index[[[key]]]].layout != null) {
                        angular.forEach(scope.configblocks[[[key]]].Options[0].imageLayout, function (option, iterKey) {
                            if (option.res == scope.configblocks[[[key]]].ConfigurationValue.ValueArray[scope.index[[[key]]]].layout[0].res) {
                                option.ticked = true;
                            } else {
                                option.ticked = false;
                            }
                        });
                    }
                };
                scope.initSinglePicker = function (key) {//multi attachment picker
                    if (scope.configblocks[[[key]]].ConfigurationValue.ValueArray[scope.index[[[key]]]].layout != null && scope.configblocks[[[key]]].ConfigurationValue.ValueArray[scope.index[[[key]]]].layout.length > 0) {
                        angular.forEach(scope.configblocks[[[key]]].Options[0].imageLayout, function (option, iterKey) {
                            if (option.res == scope.configblocks[[[key]]].ConfigurationValue.ValueArray[scope.index[[[key]]]].layout[0].res) {
                                option.ticked = true;
                            } else {
                                option.ticked = false;
                            }
                        });
                    } else {
                        angular.forEach(scope.configblocks[[[key]]].Options[0].imageLayout, function (option, iterKey) {
                            option.ticked = false;
                        });
                        scope.configblocks[[[key]]].Options[0].imageLayout[0].ticked = true;
                    }
                }

                if (typeof scope.configblocks != 'undefined') {//multi attachment picker
                    for (var config = 0; config < scope.configblocks.length; config++) {
                        scope.index[config] = 0;
                    }
                }

                scope.getAllowedMedia = function (key) {
                    if (scope.configblocks[key].Options[0].image == true && scope.configblocks[key].Options[0].video == true) return 2;
                    if (scope.configblocks[key].Options[0].image == true && scope.configblocks[key].Options[0].video == false) return 0;
                    else return 3;
                }

                scope.removeAttachment = function (index, key) {//multi attachment picker
                    scope.configblocks[key].ConfigurationValue.ValueArray.splice(index, 1);
                    scope.change = 1;
                    scope.index[key] = 0;
                }

                scope.moveUpAttachment = function (index, key) {//multi attachment picker
                    if (index == 0) return;
                    var upItem = scope.configblocks[key].ConfigurationValue.ValueArray[index];
                    var downItem = scope.configblocks[key].ConfigurationValue.ValueArray[index - 1];
                    scope.configblocks[key].ConfigurationValue.ValueArray[index] = downItem;
                    scope.configblocks[key].ConfigurationValue.ValueArray[index - 1] = upItem;

                    scope.change = 1;
                    scope.index[key] = index - 1;
                }

                scope.moveDownAttachment = function (index, key) {//multi attachment picker
                    if (index == scope.configblocks[key].ConfigurationValue.ValueArray.length - 1) return;
                    var downItem = scope.configblocks[key].ConfigurationValue.ValueArray[index];
                    var upItem = scope.configblocks[key].ConfigurationValue.ValueArray[index + 1];

                    scope.configblocks[key].ConfigurationValue.ValueArray[index + 1] = downItem;
                    scope.configblocks[key].ConfigurationValue.ValueArray[index] = upItem;

                    scope.change = 1;
                    scope.index[key] = index + 1;
                }

                scope.ReplaceSelectedAsset = function (type, key, index) {
                    var passObj = {};

                    if (type != undefined) {
                        passObj.HideVideos = type == 0;
                        passObj.HideImages = type == 1;
                        passObj.DisableFilters = type != 2;
                        passObj.Multiple = false;
                    }

                    var modalObj = {
                        name: 'MediaAssetSelector',
                        windowClass: 'assetPopup nestedModal',
                        resolvedCallback: replaceSelectedAsset,
                        passObj: passObj
                    }

                    modal2.open(modalObj);

                    function replaceSelectedAsset(assets) {
                        var asset = assets.pop();
                        scope.configblocks[key].ConfigurationValue.ValueArray[index].FileType = asset.AssetType;
                        //from existing assets we get Title, but from uploaded AssetTitle :)))
                        scope.configblocks[key].ConfigurationValue.ValueArray[index].AttachmentTitle = asset.AssetTitle || asset.Title;
                        scope.configblocks[key].ConfigurationValue.ValueArray[index].Media = asset;
                    }
                }

                scope.clearOtherTabSelection = function (key, tab) {//colorVideImagePicker
                    scope.configblocks[key].ConfigurationValue.Active = tab;//set active tab
                }

                scope.ClearColImgVid = function (configObj) {

                    if (configObj.Color != undefined)
                        configObj.Color = '#000';
                    if (configObj.Image != undefined)
                        configObj.Image = {};
                    if (configObj.Video != undefined)
                        configObj.Video = {};
                }

                scope.clearLogo = function (key) {
                    scope.configblocks[key].ConfigurationValue = {
                        LogoAspect: false,
                        LogoHasLayer: false,
                        LogoResize: false
                    }
                }

                scope.resetMedia = function (mediaObj) {
                    mediaObj = {};
                }

                scope.LogoTopLeftXchange = function (configValue, key, settings) {//Positioning & Region

                    var width, height, unitRatioW, unitRatioH;
                    if (settings == undefined || (settings.landscapeMode == undefined || settings.landscapeMode == true)) {
                        width = 300;
                        height = 169;
                    }
                    else {
                        width = 169;
                        height = 300;
                    }
                    unitRatioW = parseFloat((1 / width).toFixed(5));
                    unitRatioH = parseFloat((1 / height).toFixed(5));

                    if (configValue.topLeftX < 0) configValue.topLeftX = 0;
                    if (configValue.sizeRatio == undefined) {
                        configValue.topLeftX = undefined;
                        return;
                    }
                    if (isNaN(configValue.topLeftX)) configValue.topLeftX = 0;
                    var target = $('#positionBox' + key)[0];
                    var x = Math.round((configValue.topLeftX / unitRatioW) * 100) / 100;

                    if (x + configValue.size.w > width) {
                        var overLimit = (x + configValue.size.w) - width;
                        x -= overLimit;
                        configValue.topLeftX = Math.round((x * unitRatioW) * 100) / 100;
                        x = Math.round(x * 100) / 100;
                    }

                    configValue.bottomRightX = Math.round(((x + configValue.size.w) * unitRatioW) * 100) / 100;
                    $('#positionBox' + key).css('webkitTransform', 'translate(' + x + 'px,' + Math.round((configValue.topLeftY / unitRatioH) * 100) / 100 + 'px)');
                    $('#positionBox' + key).css('transform', 'translate(' + x + 'px,' + Math.round((configValue.topLeftY / unitRatioH) * 100) / 100 + 'px)');
                    target.style.webkitTransform =
                        target.style.transform = 'translate(' + x + 'px,' + Math.round((configValue.topLeftY / unitRatioH) * 100) / 100 + 'px)';
                    target.setAttribute('data-x', x);

                    if (configValue.PositionRatio == undefined) configValue.PositionRatio = {};
                    configValue.PositionRatio.x = parseFloat(x / width).toFixed(5);

                }

                scope.LogoTopLeftYchange = function (configValue, key, settings) {//Positioning & Region

                    var width, height, unitRatioW, unitRatioH;
                    if (settings == undefined || (settings.landscapeMode == undefined || settings.landscapeMode == true)) {
                        width = 300;
                        height = 169;
                    }
                    else {
                        width = 169;
                        height = 300;
                    }
                    unitRatioW = parseFloat((1 / width).toFixed(5));
                    unitRatioH = parseFloat((1 / height).toFixed(5));

                    if (configValue.topLeftY < 0) configValue.topLeftY = 0;
                    if (configValue.sizeRatio == undefined) {
                        configValue.topLeftY = undefined;
                        return;
                    }
                    if (isNaN(configValue.topLeftY)) configValue.topLeftY = 0;
                    var target = $('#positionBox' + key)[0];
                    var y = Math.round((configValue.topLeftY / unitRatioH) * 100) / 100;
                    if (y < 0) y = 0;
                    if (y + configValue.size.h > height) {
                        var overLimit = (y + configValue.size.h) - height;
                        y -= overLimit;
                        if (y < 0) y = 0;

                        configValue.topLeftY = Math.round((y * unitRatioH) * 100) / 100;
                        y = Math.round(y * 100) / 100;
                    }

                    configValue.bottomRightY = Math.round(((y + configValue.size.h) * unitRatioH) * 100) / 100;
                    if (configValue.bottomRightY > 1) configValue.bottomRightY = 1;
                    $('#positionBox' + key).css('webkitTransform', 'translate(' + Math.round((configValue.topLeftX / unitRatioW) * 100) / 100 + 'px,' + y + 'px)');
                    $('#positionBox' + key).css('transform', 'translate(' + Math.round((configValue.topLeftX / unitRatioW) * 100) / 100 + 'px,' + y + 'px)');
                    target.style.webkitTransform =
                        target.style.transform = 'translate(' + Math.round((configValue.topLeftX / unitRatioW) * 100) / 100 + 'px,' + y + 'px)'
                    target.setAttribute('data-y', y);


                    if (configValue.PositionRatio == undefined) configValue.PositionRatio = {};
                    configValue.PositionRatio.y = parseFloat(y / height).toFixed(5);
                }

                scope.LogoBottomRightXchange = function (configValue, key, settings) {//Positioning & Region

                    if (configValue.bottomRightX == 0 || configValue.bottomRightX == null) {
                        return;
                    }
                    var width, height, unitRatioW, unitRatioH;
                    if (settings == undefined || (settings.landscapeMode == undefined || settings.landscapeMode == true)) {
                        width = 300;
                        height = 169;
                    }
                    else {
                        width = 169;
                        height = 300;
                    }
                    unitRatioW = parseFloat((1 / width).toFixed(5));
                    unitRatioH = parseFloat((1 / height).toFixed(5));

                    if (configValue.bottomRightX == undefined) configValue.bottomRightX = 1;
                    if (configValue.bottomRightX < 0) configValue.bottomRightX = 0;
                    if (configValue.sizeRatio == undefined) {
                        configValue.bottomRightX = undefined;
                        return;
                    }
                    if (configValue.bottomRightX - configValue.topLeftX < 0.09) {
                        var difference = configValue.bottomRightX - configValue.topLeftX;
                        if (difference == 0) configValue.bottomRightX += 0.01;
                        else if (difference < 0) configValue.bottomRightX = configValue.topLeftX + 0.01;
                    }
                    configValue.bottomRightX = Math.round((configValue.bottomRightX / unitRatioW) * 100) / 100;
                    if (configValue.bottomRightX > width) configValue.bottomRightX = width;
                    var target = $('#positionBox' + key)[0];
                    var w = Math.round((configValue.bottomRightX - (configValue.topLeftX / unitRatioW)) * 100) / 100;

                    if (configValue.LogoAspect) {

                        var h = Math.round((configValue.orgHeight * w / configValue.orgWidth) * 100) / 100;
                        if (h > height) {
                            h = height;
                            w = Math.round((configValue.orgWidth * h / configValue.orgHeight) * 100) / 100;
                        }

                        configValue.bottomRightY = Math.round(((h * unitRatioH) + configValue.topLeftY) * 100) / 100;
                        if (configValue.bottomRightY > 1) {
                            configValue.bottomRightY = 1;
                            scope.LogoBottomRightYchange(configValue, key, settings);
                            return;
                        }

                        configValue.bottomRightX = Math.round(((w * unitRatioW) + configValue.topLeftX) * 100) / 100;
                        if (w > 0) configValue.size.w = w;
                        target.style.width = w + 'px';
                        configValue.bottomRightY = Math.round(((h * unitRatioH) + configValue.topLeftY) * 100) / 100;

                        if (h > 0) configValue.size.h = h;
                        target.style.height = h + 'px';

                        configValue.sizeRatio.w = w / width;
                        configValue.sizeRatio.h = h / height;

                    }

                    target.style.width = w + 'px';
                    configValue.sizeRatio.w = w / width;
                    if (!configValue.LogoAspect) configValue.bottomRightX = Math.round((configValue.bottomRightX * unitRatioW) * 100) / 100;
                    else configValue.bottomRightX = Math.round((configValue.bottomRightX) * 100) / 100;
                    if (w > 0) configValue.size.w = w;
                    if (configValue.bottomRightX > 1) configValue.bottomRightX = 1;

                    var middleBoxX = $('#positionBox' + key).find('.middleboxX');
                    middleBoxX.css({ 'left': ((w / 2) - 5) + 'px' });
                    var middleBoxY = $('#positionBox' + key).find('.middleboxY');
                    middleBoxY.css({ 'top': ((h / 2) - 5) + 'px' });


                }

                scope.LogoBottomRightYchange = function (configValue, key, settings) {//Positioning & Region

                    if (configValue.bottomRightY == 0 || configValue.bottomRightY == null) {
                        return;
                    }
                    var width, height, unitRatioW, unitRatioH;
                    if (settings == undefined || (settings.landscapeMode == undefined || settings.landscapeMode == true)) {
                        width = 300;
                        height = 169;
                    }
                    else {
                        width = 169;
                        height = 300;
                    }
                    unitRatioW = parseFloat((1 / width).toFixed(5));
                    unitRatioH = parseFloat((1 / height).toFixed(5));

                    if (configValue.bottomRightY == undefined) configValue.bottomRightY = 1;
                    if (configValue.bottomRightY < 0) configValue.bottomRightY = 0;
                    if (configValue.sizeRatio == undefined) {
                        configValue.bottomRightY = undefined;
                        return;
                    }
                    if (configValue.bottomRightY - configValue.topLeftY < 0.09) {
                        var difference = configValue.bottomRightY - configValue.topLeftY;
                        if (difference == 0) configValue.bottomRightY += 0.01;//0.1
                        else if (difference < 0) configValue.bottomRightY = configValue.topLeftY + 0.01;
                    }

                    configValue.bottomRightY = Math.round((configValue.bottomRightY / unitRatioH) * 100) / 100;
                    if (configValue.bottomRightY > height) configValue.bottomRightY = height;
                    var target = $('#positionBox' + key)[0];

                    var h = Math.round((configValue.bottomRightY - (configValue.topLeftY / unitRatioH)) * 100) / 100;
                    if (configValue.LogoAspect) {
                        var w = Math.round((configValue.orgWidth * h / configValue.orgHeight) * 100) / 100;
                        if (settings == undefined || (settings.landscapeMode == undefined || settings.landscapeMode == true)) {
                            if (w > width) {
                                h = height;
                                w = Math.round((configValue.orgWidth * h / configValue.orgHeight) * 100) / 100;
                            }
                            if (w > width) {//if width is still too big
                                w = width;
                                h = Math.round((configValue.orgHeight * w / configValue.orgWidth) * 100) / 100;
                            }
                        }
                        else {
                            if (w > width) {
                                w = width;
                                h = Math.round((configValue.orgHeight * w / configValue.orgWidth) * 100) / 100;
                            }
                        }
                        configValue.bottomRightX = Math.round(((w * unitRatioW) + configValue.topLeftX) * 100) / 100;
                        if (configValue.bottomRightX > 1) {
                            configValue.bottomRightX = 1;
                            w = Math.round((width - (configValue.topLeftX / unitRatioW)) * 100) / 100;
                            h = Math.round((configValue.orgHeight * w / configValue.orgWidth) * 100) / 100;
                        }
                        if (w > 0) configValue.size.w = w;
                        target.style.width = w + 'px';
                        configValue.bottomRightY = Math.round(((h * unitRatioH) + configValue.topLeftY) * 100) / 100;


                        configValue.bottomRightY = Math.round(((h * unitRatioH) + configValue.topLeftY) * 100) / 100;
                        if (configValue.bottomRightY > 1) configValue.bottomRightY = 1;
                        if (h > 0) configValue.size.h = h;
                        target.style.height = h + 'px';

                        configValue.sizeRatio.w = w / width;
                        configValue.sizeRatio.h = h / height;
                    }
                    else {
                        target.style.height = h + 'px';
                        configValue.sizeRatio.h = h / height;

                        configValue.bottomRightY = Math.round(((configValue.bottomRightY * unitRatioH)) * 100) / 100;
                        if (h > 0) configValue.size.h = h;
                    }
                    if (configValue.bottomRightY > 1) configValue.bottomRightY = 1;

                    var middleBoxX = $('#positionBox' + key).find('.middleboxX');
                    middleBoxX.css({ 'left': ((w / 2) - 5) + 'px' });
                    var middleBoxY = $('#positionBox' + key).find('.middleboxY');
                    middleBoxY.css({ 'top': ((h / 2) - 5) + 'px' });

                }

                scope.PreviewApp = function (baseUrl) {
                    if (baseUrl.indexOf('?') != -1)
                        baseUrl.slice(0, -1);
                    var urlQuery = '?campaignID=' + scope.campaignid;

                    var blockType = ConfigBlockHelper.configurationBlockType;

                    angular.forEach(scope.configblocks, function (configBlock) {
                        switch (configBlock.BlockName) {
                            case blockType.effectSelect:
                                var effectNames = [], effectUrls = [];
                                angular.forEach(configBlock.Options, function (opt) {
                                    if (opt.selected) {
                                        effectNames.push(opt.value.name);
                                        effectUrls.push(opt.value.url);
                                    }
                                });
                                urlQuery = urlQuery.concat('&effectNames=', effectNames.join(), '&effectUrls=', effectUrls.join());
                                break;
                            case blockType.singleSelect:
                                angular.forEach(configBlock.Options, function (opt) {
                                    if (opt.ticked)
                                        urlQuery = urlQuery.concat('&', configBlock.Code, '=', opt.res);
                                });
                                break;
                            case blockType.positioning:
                                if (!(configBlock.ConfigurationValue.Image == undefined || configBlock.ConfigurationValue.Image == null))
                                    urlQuery = urlQuery.concat('&posImgUrl=', encodeURI(configBlock.ConfigurationValue.Image.FileURL), '&posBottomRightX=', configBlock.ConfigurationValue.bottomRightX, '&posBottomRightY=', configBlock.ConfigurationValue.bottomRightY, '&posTopLeftX=', configBlock.ConfigurationValue.topLeftX, '&posTopLeftY=', configBlock.ConfigurationValue.topLeftY, '&posLLX=', configBlock.ConfigurationValue.topLeftX, '&posLLY=', configBlock.ConfigurationValue.bottomRightY, '&posURX=', configBlock.ConfigurationValue.bottomRightX, '&posURY=', configBlock.ConfigurationValue.topLeftY);
                                break;
                        }
                    });
                    $window.open(baseUrl + urlQuery, '_blank');
                }

                //used in mediaList directive for ctrl & shift selections
                var activeAssetIndex = 0;
                scope.selectAssets = function (block) {
                    var passObj = {
                        HideVideos: !block.Options.videos,
                        HideImages: !block.Options.images,
                        MultipleLimit: block.Options.maxFiles,
                        Multiple: block.Options.maxFiles != null,
                        DisableFilters: block.Options.disableFilters
                    }

                    var modalObj = {
                        name: 'MediaAssetSelector',
                        windowClass: 'assetPopup nestedModal',
                        resolvedCallback: function (assets) {
                            addSelectedAssets(block, assets);
                        },
                        passObj: passObj
                    }

                    modal2.open(modalObj);
                }

                //need to pass block, not the whole assets array. Otherwise reference is broken - i think
                function addSelectedAssets(block, assets) {
                    activeAssetIndex = 0;
                    assets = assets.map(function (asset) {
                        return {
                            MediaAssetID: asset.MediaAssetID,
                            FileURL: asset.FileURL,
                            IconURL: asset.IconUrl,
                            Duration: asset.DurationInSeconds,
                            AssetType: asset.AssetType,
                            Resolution: asset.Resolution,
                            Title: asset.Title
                        }
                    });

                    block.ConfigurationValue = block.ConfigurationValue.concat(assets);
                }
                scope.removeSelectedAssets = function (block) {
                    activeAssetIndex = 0;
                    block.ConfigurationValue = block.ConfigurationValue.filter(function (asset) { return !asset.selected });
                }

                scope.removeAsset = function (block, asset) {
                    activeAssetIndex = 0;
                    block.ConfigurationValue = block.ConfigurationValue.filter(function (ass) { return ass !== asset });
                }

                scope.toggleAssetSelection = function (assets, currentAsset, $index, $event) {
                    if ($event.shiftKey) {
                        var startIndex = Math.min(activeAssetIndex, $index);
                        var endIndex = Math.max(activeAssetIndex, $index);
                        assets.forEach(function (asset, assetIndex) {
                            asset.selected = assetIndex >= startIndex && assetIndex <= endIndex;
                        });
                    }
                    else {
                        activeAssetIndex = $index;
                        if (!$event.ctrlKey)
                            assets.forEach(function (ass) { ass.selected = false; });
                        currentAsset.selected = !currentAsset.selected;
                    }
                }

                scope.$watch('[change]', function () {
                    if (typeof scope.configblocks != 'undefined') {
                        scope.change = 0;
                        element.html(getTemplate(scope.configblocks, scope.blocktemplates, scope.fun, scope.ngModel, scope.canManage, scope.advancedGroupList, scope.advancedBlockGroups)).show();
                        $compile(element)(scope);
                    }
                }, true);

                scope.$watch('drawchange', function (newValue, oldValue) {
                    if (scope.configblocks != undefined && scope.blocktemplates != undefined) {
                        element.html(getTemplate(scope.configblocks, scope.blocktemplates, scope.fun, scope.ngModel, scope.canManage, scope.advancedGroupList, scope.advancedBlockGroups)).show();
                        $compile(element)(scope);
                    }
                }
                );
            }
            //end
        }
    }]);